module.exports = __webpack_public_path__ + "img/shelves-empty.b76fba70.svg";